import { Clipboard } from '@angular/cdk/clipboard';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ToastService } from '@vsolv/vectors-ui/alert';
import { TableCellComponent } from '../../models';

export interface UserInfoCellProps {
  photoUrl?: string | null;
  name?: string | null;
  email?: string | null;
  emptyText?: string | null;
  /** When set, shows a copy button that copies this text (and stops row navigation). */
  copyText?: string | null;
}

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
  template: `
    <div *ngIf="data && (data.name || data.email || data.photoUrl); else elseTmpl" class="flex items-center gap-3">
      <vs-user-avatar [config]="{ photoUrl: data.photoUrl ?? undefined }" class="w-10 h-10"></vs-user-avatar>
      <div class="min-w-0">
        <div *ngIf="data.name" class="flex items-center gap-2 min-w-0">
          <p class="text-sm font-medium text-gray-900 truncate">{{ data.name }}</p>
          <button
            *ngIf="data.copyText"
            vs-icon-button
            type="button"
            size="sm"
            appearance="clear"
            class="shrink-0 p-0 h-5 w-5 -my-1"
            aria-label="Copy name"
            [vsTooltip]="'Copy to clipboard'"
            tooltipStyle="light"
            (click)="copyName($event)"
          >
            <vs-icon name="copy-01" class="h-4 w-4 text-gray-600"></vs-icon>
          </button>
        </div>
        <p *ngIf="data.email" class="text-xs font-normal text-gray-600">{{ data.email }}</p>
      </div>
    </div>
    <ng-template #elseTmpl>
      <div class="w-full text-xs font-normal text-gray-600 text-center">
        {{ data?.emptyText ?? '' }}
      </div>
    </ng-template>
  `,
})
export class UserInfoCellComponent extends TableCellComponent<UserInfoCellProps> {
  private readonly clipboard = inject(Clipboard);
  private readonly toastSvc = inject(ToastService);

  copyName(event: Event) {
    event.stopImmediatePropagation();
    const text = this.data?.copyText;
    if (!text) return;
    this.clipboard.copy(text);
    this.toastSvc.show({
      type: 'success',
      title: 'Copied!',
      text: 'Customer name copied to clipboard',
    });
  }
}
